import React from 'react';
import {Form, Formik, Field } from "formik";
import {Button, Col, Divider, Layout, Row, Select, Input, DatePicker} from "antd";
import DatePickerInput, {InputWrap, SelectWrap} from "../../components/datePickerInput";
import {compose} from "redux";
import {firebaseConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import moment from "moment";
import transections from "../transections";
import * as yup from 'yup';
const {Content} = Layout;
const { Option } = Select;

const transactionsSchema = yup.object().shape({
    title: yup.string().isRequired,
});
const EditTransaction = ({
    categories = [],
    paymentMode = [],
    location,
    history,
    firebase,
     uid,
     match,
 }) => {
    const handleSubmit = (values) => {
        firebase.ref(`data/${uid}/${location.state.id}`).set(values).then(() => {
            history.goBack();
        });
    };
    return (
        <Formik
            initialValues={location.state}
            onSubmit={handleSubmit}
            validationSchema={transactionsSchema}
            enableReinitialize
        >
            {({
              isSubmitting,
              isValid,
              values,
              setFieldValue,
              }) => (
                <Form>
                    <Content>
                        <Row type="flex" justify='center'>
                            <Col span={22}>
                                <Divider />
                                <h1>Edit Transaction</h1>
                                <Divider />
                                <Field
                                    name="title"
                                    value={values.title}
                                    onChange={(e) => setFieldValue('title', e.target.value)}
                                    component={Input}
                                    type="text"
                                    placeholder="Title"
                                    className="form-input"
                                />
                                <Field
                                    name="amount"
                                    value={values.amount}
                                    onChange={(e) => setFieldValue('amount', e.target.value)}
                                    component={Input}
                                    type="text"
                                    placeholder="Amount"
                                    className="form-input"
                                />
                                <DatePicker
                                    autoOk
                                    className="form-input"
                                    defaultValue={values.date ? moment(values.date) : moment()}
                                    onChange={(e) => setFieldValue('date', e.target.value)}
                                />
                                <Field
                                    name="category"
                                    component={Select}
                                    type="text"
                                    value={values.category}
                                    onChange={(e) => setFieldValue('category', e.target.value)}
                                    placeholder="Category"
                                    className="form-input"
                                >
                                    {categories.length > 0 && categories.map((item) => (
                                        <Option key={item.key} value={item.value}>{item.value}</Option>
                                    ))}
                                </Field>
                                <Field
                                    name="paymentMode"
                                    component={Select}
                                    value={values.mode}
                                    onChange={(e) => setFieldValue('mode', e.target.value)}
                                    type="text"
                                    placeholder="Payment Mode"
                                    className="form-input"
                                >
                                    {paymentMode.length > 0 && paymentMode.map((item) => (
                                        <Option key={item.key} value={item.value.name}>{item.value.name} {item.value.balance}</Option>
                                    ))}
                                </Field>
                                <Button disabled={!isValid || isSubmitting} type="primary" onClick={() => handleSubmit(values)} size="medium">Submit</Button>
                                <Button onClick={() => history.goBack()} size="medium">Cancel</Button>
                                <br /><br />
                            </Col>
                        </Row>
                    </Content>
                </Form>
            )}
        </Formik>
    );
};

const FormEnhancer = compose(
    firebaseConnect((props) => (
        [
            'Categories',
            {
                path: `accounts/${props.uid}/`,
                storeAs: 'paymentMode',
            }
        ]
    )),
    connect(({firebase}) => ({
        categories: firebase.ordered.Categories,
        paymentMode: firebase.ordered.paymentMode,
        uid: firebase.auth.uid,
    })))(EditTransaction);

export default connect(({firebase}) => ({
    uid: firebase.auth.uid
}))(FormEnhancer);



// WEBPACK FOOTER //
// ./src/pages/Transactions/EditTransaction.js